const getInitialState = () => ({
  isSecondaryPanelVisible: false,
  secondaryPanelContentType: null,
  isShowingSpeakers: true,
})

// oxlint-disable-next-line import/no-default-export
export default ({ actionNames }) => {
  const initialState = getInitialState()

  // oxlint-disable-next-line default-param-last
  return (state = initialState, action) => {
    switch (action.type) {
      case actionNames.INIT: {
        return {
          ...state,
          selectedSidebarTab: action.defaultSidebarTab,
        }
      }
      case actionNames.TOGGLE_SECONDARY_PANEL: {
        const isSecondaryPanelVisible = !state.isSecondaryPanelVisible

        return {
          ...state,
          isSecondaryPanelVisible,
          secondaryPanelContentType: action.payload[0] || null,
        }
      }
      /**
       * Since this is a sub feature that is dispatching this action, we have to
       *  hardcode it since we can't get to it otherwise.
       */
      case 'INFO-PANEL-SPEAKERS:FETCH_SUCCESS': {
        const { speakers } = action

        return {
          ...state,
          isShowingSpeakers: !!speakers?.length,
        }
      }
      default:
        return state
    }
  }
}
